export const removeByKey = (obj, key) => {
    const newObj = { ...obj };
    delete newObj[key];
    return newObj;
};
